import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../../../../_models/user-name-display-result-dto';

export class DepositResultDto extends UserNameDisplayResultDto {
    cmDepositId: number;
    managementCompanyId: number;
    communityId: number;
    amount: number;
    reconciled: boolean;
    description: string;
    bankAccountName: string;
    bankName: string;
    accountType: string;
    protectedAccountNumber: string;
    allowDelete: boolean;
    allowEdit: boolean;
    allowLimitedEdit: boolean;
    allowReverse: boolean;

    @Type(() => Date)
    clearDate: Date;

    @Type(() => Date)
    reversedDate: Date;

    @Type(() => Date)
    postDate: Date;

    @Type(() => Date)
    updatedTime: Date;
}
